<template>
  <div class="check-source-stage-sidebar">
    <app-panel :title="`Проверьте базу <${importInfo.db_connection.toUpperCase()}>`">
      <div>
        <div class="check-source-stage-sidebar__info-block">
          <div class="check-source-stage-sidebar__info-block-header">
            <div class="check-source-stage-sidebar__info-block-header-icon">
              <app-icon name="InfoIcon2" size="20px"/>
            </div>
            <span class="check-source-stage-sidebar__info-block-header-text">Список обрабатываемых названий типов приборов:</span>
          </div>
          <ul class="check-source-stage-sidebar__info-block-tags">
            <li>ХВС1</li>
            <li>ХВС2</li>
            <li>ГВС1</li>
            <li>ГВС2</li>
            <li>Эл.эн.(день)</li>
            <li>Эл/эн(н)</li>
            <li>Эл.эн.(ночь)</li>
            <li>Эл.эн(н)</li>
            <li>Отопление</li>
          </ul>
        </div>

        <div class="check-source-stage-sidebar__info-block">
          <div class="check-source-stage-sidebar__info-block-header">
            <div class="check-source-stage-sidebar__info-block-header-icon">
              <app-icon name="InfoIcon2" size="20px"/>
            </div>
            <span class="check-source-stage-sidebar__info-block-header-text">Проверьте:</span>
          </div>
          <ul class="check-source-stage-sidebar__info-block-list">
            <li>Соответствие типов приборов</li>
            <li>Наличие показаний у приборов каждого типа</li>
            <li>Наличие в именах собственников сразу нескольких людей</li>
            <li>Наличие пробела в номере квартиры</li>
            <li>Квартиры с нецифровыми номерами (напр. "офис")</li>
          </ul>
        </div>

      </div>
    </app-panel>
  </div>
</template>

<script>
  export default {
    name: "CheckSourceStageSidebar",
    props: {
      importInfo: {}
    }
  }
</script>

<style lang="scss">
  .check-source-stage-sidebar {
    width: 100%;
    max-width: 420px;

    &__info-block {
      border: 1px dashed rgba(0, 0, 0, .2);
      padding: 15px 10px;

      &+&{
        margin-top: 30px;
      }

      &-header {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        color: rgba(var(--app-success), 1);

        &-icon {
          margin-right: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        &-text {
          line-height: 1.1;
        }
      }

      &-tags{
        display: flex;
        flex-wrap: wrap;
        margin-bottom: -10px;
        margin-right: -10px;

        li{
          line-height: 1.1;
          background: rgba(0, 0, 0, .1);
          padding: 8px 10px;
          font-size: 12px;
          margin: 0 10px 10px 0;
          border-radius: 5px;
          font-weight: 500;
        }
      }

      &-list{
        margin-top: 30px;
        padding-left: 5px;
        margin-bottom: -15px;

        li{
          line-height: 1.1;
          position: relative;
          padding-left: 20px;
          margin-bottom: 15px;


          &::before{
            content: "";
            height: 2px;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 10px;
            background: #627084;
            position: absolute;
          }
        }


      }
    }

    &__checklist{
      margin-top: 30px;

      &-row{
        margin-left: 15px;
        margin-bottom: 15px;

        .con-slot-label{
          line-height: 1.1;
        }
      }
    }
  }
</style>